import { Button } from 'react-bootstrap';

/**
 * Novo componente para Assinatura Eletrônica com HASH SHA-256 gerado pelo Backend.
 *
 * @param {Object} props
 * @param {string} props.hash - Hash SHA-256 vindo da coluna HASH_INTEGRIDADE do banco
 * @param {string} props.nome - Nome do médico que realizou/assinou
 * @param {boolean} [props.showPrintButton=false] - Exibe botão de impressão simples
 * @param {Function} [props.imprimirLaudo] - Função callback para impressão
 */
const AssinaturaDigital = ({
  hash,
  nome,
  showPrintButton = false,
  imprimirLaudo = () => window.print(),
}) => {
  return (
    <div className="text-center mt-3 pt-2">
      {hash ? (
        <p className="mb-1 text-muted" style={{ fontSize: '0.85rem' }}>
          <i>Assinatura Digital: </i>
          <strong className="text-break text-dark">{hash}</strong>
        </p>
      ) : (
        <p className="mb-1 text-muted" style={{ fontSize: '0.85rem' }}>
          <i>Assinatura Digital: </i>
          <span className="text-warning">Pendente (Laudo em Parcial / Rascunho)</span>
        </p>
      )}

      {nome && (
        <p className="mb-0" style={{ fontSize: '0.9rem' }}>
          Conferido e assinado eletronicamente por: <strong>Dr(a). {nome}</strong>
        </p>
      )}

      {showPrintButton && (
        <Button variant="outline-primary" size="sm" className="mt-2" onClick={imprimirLaudo}>
          Imprimir
        </Button>
      )}
    </div>
  );
};

export default AssinaturaDigital;
